var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBehanceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 13,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5832 8.46667H14.6249V7H19.5832V8.46667ZM20.8057 15.8C20.4927 16.7511 19.3685 18 17.1926 18C15.0152 18 13.2514 16.7321 13.2514 13.8383C13.2514 10.971 14.8983 9.497 17.1231 9.497C19.3062 9.497 20.6393 10.8038 20.9304 12.7427C20.9857 13.1138 21.0076 13.6139 20.9977 14.3121H15.312C15.404 16.6668 17.7791 16.7409 18.5618 15.8H20.8057ZM15.3615 12.8667H18.8784C18.804 11.7322 18.0737 11.2394 17.1239 11.2394C16.0855 11.2394 15.511 11.8026 15.3615 12.8667ZM8.58003 17.9912H4V7.0154H8.92499C12.8038 7.0748 12.8774 11.0077 10.8516 12.0798C13.3032 13.0038 13.3853 17.9912 8.58003 17.9912ZM6.12498 11.4H8.66362C10.4401 11.4 10.722 9.2 8.44262 9.2H6.12498V11.4ZM8.52691 13.6H6.12498V15.8117H8.49149C10.6554 15.8117 10.523 13.6 8.52691 13.6Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBehanceIcon);
export default __webpack_public_path__ + "static/media/behance-icon.498ab0c687c9c3e9445fb13e2a18d5e6.svg";
export { ForwardRef as ReactComponent };